import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {
  transform(items: any[], filter: any, type: any, paceEnabled:boolean): any {
    if (!items || !filter) {
      return items;
    }
    filter=filter.toLowerCase();
    // console.log(paceEnabled, filter);
    if (type === "activity")
    // filter items array, items which match and return true will be kept, false will be filtered out
    {
      if(paceEnabled)
      {
          return items.filter(item => item.activityName.toLowerCase().indexOf(filter) > -1 && item['paceAction'] !== 'HIDE');
      }
      return items.filter(item => item.activityName.toLowerCase().indexOf(filter) > -1);
    }

    else if (type === "topic")
    // filter items array, items which match and return true will be kept, false will be filtered out
    {
      return items.filter(item => this.testg(item, filter, paceEnabled));
    }
    else if(type === "conceptName")
    {
      return items.filter(item => item.conceptName.toLowerCase().indexOf(filter) > -1);
    }
    else if(type === "quizName")
    {
      return items.filter(item => item.quizName.toLowerCase().indexOf(filter) > -1);
    }
  }

  testg(topic: any, filter: any, paceEnabled:boolean): Boolean {
    for (var i = 0; i < topic.activities.length; i++)
    {
      if(paceEnabled)
      {
        debugger;
        if((topic.activities[i].activityName.toLowerCase().indexOf(filter) > -1) && (topic.activities[i].paceAction !== "HIDE"))
        {
          return true;
        }
      }
      else
      {
        if (topic.activities[i].activityName.toLowerCase().indexOf(filter) > -1)
        {
          return true;
        }
      }
    }
    return false;
  }


}
